import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_BA.json';
import audios from './LOVE_AUDIOS_BA.json';

export const LOVE_DATA_BA: ServiceData = {
  articles,
  audios,
};
